import type { IconDefinition } from '../../types'

export default {
  details: [384, 512, [], '', 'M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z'],
  name: 'uiMinus',
  oldName: 'falMinus'
} as IconDefinition
